import type { KeyboardEvent } from "react";

export function isKeyboardActivationKey(e: KeyboardEvent): boolean {
    if (e.repeat) {
        return false;
    }

    return e.key === "Enter" || e.key === " " || e.code === "NumpadEnter";
}

export function handleKeyboardActivation<E extends HTMLElement>(
    e: KeyboardEvent<E>,
    onActivate: () => void
): void {
    if (e.target !== e.currentTarget) {
        return;
    }

    if (!isKeyboardActivationKey(e)) {
        return;
    }

    e.preventDefault();
    onActivate();
}
